import React from 'react';
import './index.css';

export default function Divider() {
  return (
    <div className="divider">
    </div>
  )
}
